module.exports = __webpack_public_path__ + "static/screen4-e53ca8b2fe5e175d86fb76dd999da760.png";